import * as React from 'react'
import {createStyles, Grid, Theme, Typography, WithStyles, withStyles} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {connect} from 'react-redux'
import {RootState} from 'src/core/redux/reducer/index'
import {compose} from 'redux'
import ConsumerCard from './ConsumerCard'
import Page from 'src/shared/Page/Page'
import {WithGlobalProgress} from 'src/type/lib/withGlobalProgress'
import {WithToast} from 'src/type/lib/withToast'
import autobind from 'autobind-decorator'
import {withToast} from 'src/shared/Toast'
import { AnimateList } from 'src/shared/Animate'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { withRouter, RouteComponentProps } from 'react-router'

const styles = (t: Theme) => createStyles({
  head: {
  },
  body: {
    marginTop: t.spacing.unit * 6,
    marginBottom: t.spacing.unit,
  },
  consumersWpr: {
    margin: '0 auto',
    width: '50%',
    [t.breakpoints.down('xs')]: {
      width: '100%',
    },
  }
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  RouteComponentProps<any>,
  WithToast,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

class Consumers extends React.Component<IProps, any> {

  render() {
    const {accountInfo, t, classes} = this.props
    return (
      <>
        <Page>
          <div className={classes.head}>
            <Typography variant="h5" align="center" gutterBottom>{t.Consumers_title}</Typography>
            {accountInfo && accountInfo.enterprises!.length === 0 &&
              <Typography variant="subtitle1" align="center" color="textSecondary" gutterBottom>{t.Consumers_welcome_without_enterprise}</Typography>
            }
            {accountInfo && accountInfo.enterprises!.length > 0 &&
              <>
                <Typography variant="subtitle1" align="center" color="textSecondary" gutterBottom>{t.Consumers_welcome_with_enterprise_first}</Typography>
                <br/>
                <div className={classes.consumersWpr}>
                <Grid container>
                  <AnimateList>
                    {this.enterprisesRendering(accountInfo.enterprises)}
                  </AnimateList>
                </Grid>
                </div>
              </>
            }
          </div>

        </Page>
        {/* <Footer /> */}
      </>
    )
  }

  componentDidMount(){
    const {accountInfo} = this.props
    if(accountInfo.enterprises && accountInfo.enterprises.length === 1){
      this.props.history.push(`/ptf/enterprise/${accountInfo.enterprises[0].id}`)
    }
  }

  @autobind
  private enterprisesRendering(enterprises){
    return enterprises.map(c => {
      return(
        <Grid item xs={12} key={c.id}>
            <ConsumerCard consumer={c}/>
        </Grid>
      )
    })
  }

}

const state2props = (state: RootState) => ({
  accountInfo: state.accountInfo,
  connectedUser: state.accountInfo.connectedUser
})

const dispatch2props = (dispatch) => ({
})

export default compose(
  withRouter,
  withI18n,
  withStyles(styles),
  withGlobalProgress,
  withToast,
  connect(state2props, dispatch2props),
)(Consumers)



// WEBPACK FOOTER //
// ./src/page/Consumers/Consumers.tsx